import { render } from "./InfoGraphic.vue?vue&type=template&id=de482b40&scoped=true&ts=true"
import script from "./InfoGraphic.ts?vue&type=script&lang=ts"
export * from "./InfoGraphic.ts?vue&type=script&lang=ts"

import "./InfoGraphic.scss?vue&type=style&index=0&id=de482b40&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de482b40"]])

export default __exports__